import { useContext, useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { CardContractGenerateDoc } from './ui'
import { ICardContractGenerateDoc, ICardContractGenerateDocContainer, IContractDocumentsList } from './types'

import { useDict } from '@api/dict/state'
import { useValue } from '@hooks/useValue'

import { NotificationContext, notifyOpen } from '@ui/notification/notification.provider'


/** Контейнер окна по выбору документов для формирования */
export const CardContractGenerateDocContainer = ({isOpen, isCompany, handlerButtonOk, handlerButtonCancel}: ICardContractGenerateDocContainer) => {
    const notify = useContext(NotificationContext)

    const {isLoading, actionGetContractDocuments} = useDict(useShallow((state) => state))
    const documentsList = useValue<IContractDocumentsList[]>([])
    const txtSum = useValue<string>('')

    useEffect(() => {
        if (isOpen) {
            actionGetContractDocuments().then((res) => {
                if (res) {
                    documentsList.setValue(res.map((item) => ({
                        id: item.contractDocumentID,
                        name: item.contractDocumentName,
                        category: item.documentCategory,

                        isSelect: item.documentCategory === 'Основное' ? true : false
                    })))
                }
            })
        }

        !isOpen && clearData()
    }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

    /** Очистка формы */
    const clearData = () => {
        documentsList.setValue([])
        txtSum.setValue('')
    }

    /** Функция по выбору документов */
    const handlerSelectedDocuments = (docID: number) => {
        const newList = documentsList.value.map(item => {
            if (item.id === docID) {
                return { ...item, isSelect: !item.isSelect }
            }

            return item
        })
        
        documentsList.setValue(newList)
    }
    
    /** Кнопка сформировать */
    const handlerBtnSave = () => {
        const newList = documentsList.value.filter((item) => item.isSelect === true)
        const normalizedSum = txtSum.value.replace(/\s+/g, '')
        const invoiceSum = Number(normalizedSum)

        if (newList.length === 0) return notify && notifyOpen('Необходимо выбрать документы для формирования.', 'warning', 2000, notify)
        if (newList.some((item) => item.id === 4) && normalizedSum && (!/^\d+$/.test(normalizedSum) || !Number.isSafeInteger(invoiceSum) || invoiceSum <= 0)) {
            return notify && notifyOpen('Если сумма указана, введите её целым положительным числом.', 'warning', 2000, notify)
        }

        handlerButtonOk && handlerButtonOk(newList, normalizedSum)
    }

    /** Свойства передаваемые в компоненту */
    const propsToComponent: ICardContractGenerateDoc = {
        isOpen, isCompany, handlerButtonCancel,
        isLoading, documentsList, txtSum,
        handlerSelectedDocuments, handlerBtnSave,
    }

    return <>
        <CardContractGenerateDoc {...propsToComponent} />
    </>
}